/**
 * Calculate user level from XP
 * Formula: level = floor(xp / 500) + 1
 * This matches the backend calculation in backend/lambda/src/users/index.ts
 */
export function calculateLevel(xp: number): number {
  return Math.floor(xp / 500) + 1;
}

/**
 * Calculate XP needed for next level
 */
export function getNextLevelXP(currentLevel: number): number {
  return currentLevel * 500;
}

/**
 * Calculate progress to next level (0-1)
 */
export function getLevelProgress(xp: number): number {
  const currentLevel = calculateLevel(xp);
  const currentLevelMinXP = (currentLevel - 1) * 500;
  const nextLevelXP = currentLevel * 500;
  const xpIntoLevel = xp - currentLevelMinXP;
  const xpForLevel = nextLevelXP - currentLevelMinXP;

  return xpIntoLevel / xpForLevel;
}
